import React from 'react';
import PropTypes from 'prop-types';

import {Stack, TextField, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

import AutomationsNewGroup from './components/AutomationsNewGroup';

const AutomationsStepBasic = (props) => {
  const {
    automationName,
    existingGroup,
    groupMode,
    groupOptions,
    newGroupName,
    setAutomationName,
    setExistingGroup,
    setGroupMode,
    setNewGroupName,
    setTaskDescription,
    taskDescription,
  } = props;

  return (
    <Stack
      sx={{
        px: {
          xs: '20px',
          sm: '26px',
        },
        py: '18px',
        gap: '16px',
      }}
    >
      <Stack sx={{gap: '8px'}}>
        <Typography
          sx={{
            fontSize: '11px',
            fontWeight: 600,
            color: '#A8A49E',
            lineHeight: '100%',
            textTransform: 'uppercase',
          }}
        >
          <Translate expression='automations.Automations.New.Steps.Basic.NameTitle' />
        </Typography>
        <TextField
          fullWidth
          value={automationName}
          onChange={setAutomationName}
          placeholder={translate('automations.Automations.New.Steps.Basic.NamePlaceholder')}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
            },
            '& .MuiOutlinedInput-input': {
              px: '16px',
              py: '16px',
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '150%',
              color: '#1A1916',
              boxSizing: 'border-box',
            },
            '& .MuiOutlinedInput-input::placeholder': {
              color: '#A8A49E',
              opacity: 1,
            },
          }}
        />
      </Stack>

      <Stack sx={{gap: '8px'}}>
        <Typography
          sx={{
            fontSize: '11px',
            fontWeight: 600,
            color: '#A8A49E',
            lineHeight: '100%',
            textTransform: 'uppercase',
          }}
        >
          <Translate expression='automations.Automations.New.Steps.Basic.DescriptionTitle' />
        </Typography>
        <TextField
          fullWidth
          value={taskDescription}
          onChange={setTaskDescription}
          placeholder={translate('automations.Automations.New.Steps.Basic.DescriptionPlaceholder')}
          multiline
          minRows={2}
          maxRows={8}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              alignItems: 'flex-start',
            },
            '& .MuiOutlinedInput-input': {
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '150%',
              color: '#1A1916',
              boxSizing: 'border-box',
            },
            '& .MuiOutlinedInput-input::placeholder': {
              color: '#A8A49E',
              opacity: 1,
              whiteSpace: 'pre-line',
            },
          }}
        />
      </Stack>

      <AutomationsNewGroup
        existingGroup={existingGroup}
        groupMode={groupMode}
        groupOptions={groupOptions}
        newGroupName={newGroupName}
        setExistingGroup={setExistingGroup}
        setGroupMode={setGroupMode}
        setNewGroupName={setNewGroupName}
      />
    </Stack>
  );
};

AutomationsStepBasic.propTypes = {
  automationName: PropTypes.string.isRequired,
  existingGroup: PropTypes.string.isRequired,
  groupMode: PropTypes.string.isRequired,
  groupOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  newGroupName: PropTypes.string.isRequired,
  setAutomationName: PropTypes.func.isRequired,
  setExistingGroup: PropTypes.func.isRequired,
  setGroupMode: PropTypes.func.isRequired,
  setNewGroupName: PropTypes.func.isRequired,
  setTaskDescription: PropTypes.func.isRequired,
  taskDescription: PropTypes.string.isRequired,
};

export default React.memo(AutomationsStepBasic);
